import React from "react";

import useCustomizationContext from "../context/useCustomizationContext";
import { Link } from "@merge-api/merge-javascript-shared";
import { useHistory } from "react-router-dom";

type CustomizationChangeRowProps = {
  name: string;
  linkPath: string;
  count: number;
};

const CustomizationChangeRow = ({ name, linkPath, count }: CustomizationChangeRowProps) => {
  const { setModalTypeShown } = useCustomizationContext();
  const history = useHistory();

  if (count === 0) {
    return null;
  }

  return (
    <div className="flex flex-row items-center justify-between h-6">
      <div className="text-base font-semibold"> {name} </div>
      <Link
        onClick={() => (setModalTypeShown(null), history.push(linkPath))}
      >{`${count.toString()} ${count == 1 ? " change" : " changes"}`}</Link>
    </div>
  );
};

export default CustomizationChangeRow;
